<template>
  <main class="main" role="main">
    <div class="loading" />
  </main>
</template>
<script setup lang="ts">
import { useJsonConfig } from "~/utils/config";

definePageMeta({
  layout: 'base-layout',
  middleware: 'auth'
})

onMounted(() => {
  const config = useJsonConfig()
  window.location.href = config.CREATE_SHOW_URL
})
</script>